import AppBar from '@mui/material/AppBar';
import { HEADER, NAV } from './configLayout';

import { useResponsive } from '../../../hooks/useResponsive';
import { useTheme } from '@mui/material/styles';
import { Box, IconButton, Stack, Toolbar, alpha } from '@mui/material';
import Iconify from '../../../components/iconify';
import AccountPopover from './common/accountPopover';
import LanguagePopover from './common/languagePopover';
import SvgColor from '../../../components/svgColor';

interface Props {
  openNav: boolean;
  onOpenNav: () => void;
}

export default function Header({ openNav, onOpenNav }: Props) {
  const lgUp = useResponsive('up', 'lg');
  const theme = useTheme();

  const renderContent = (
    <>
      {!lgUp && (
        <IconButton onClick={onOpenNav} sx={{ mr: 1 }}>
          <Box component="span" sx={{ width: 24, height: 24}}>
            <SvgColor
              src={`/assets/icons/navbar/ic_menu_item.svg`}
            />
          </Box>
        </IconButton>
      )}
      <Box sx={{ flexGrow: 1 }} />
      <Stack direction="row" alignItems="center" spacing={1}>
        <LanguagePopover />
        <AccountPopover />
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        boxShadow: 'none',
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,

        backdropFilter: `blur(${6}px)`,
        WebkitBackdropFilter: `blur(${6}px)`,
        backgroundColor: alpha(theme.palette.background.default, 0.8),

        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.WIDTH + 1}px)`,
          height: HEADER.H_DESKTOP,
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}
